import { createFileRoute, redirect } from '@tanstack/react-router';

// Sign-in lives at the root. This address stays for links and bookmarks
// made before that, and carries ?next= across.
export const Route = createFileRoute('/sign-in')({
  validateSearch: (s: Record<string, unknown>): { next?: string | undefined } => (typeof s['next'] === 'string' ? { next: s['next'] } : {}),
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/', search: search.next ? { next: search.next } : {} });
  },
});
